import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import Dashboard from './Dashboard';
import TermsConditions from './TermsConditions';
import PrivacyPolicy from './PrivacyPolicy';
import SmartRedirect from './SmartRedirect';
import CpPage from './CpPage';
import FranchisePage from './FranchisePage';
import CareersPage from './CareersPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/terms-and-conditions" element={<TermsConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/admin/dashboard" element={<Dashboard />} />
      <Route path="/download" element={<SmartRedirect />} />
      <Route path="/dl" element={<SmartRedirect />} />
      <Route path="/app" element={<SmartRedirect />} />
      <Route path="/get-app" element={<SmartRedirect />} />
      <Route path="/b2b" element={<CpPage />} />
      <Route path="/franchise" element={<FranchisePage />} />
      <Route path="/careers" element={<CareersPage />} />
    </Routes>
  </BrowserRouter>
);